export default "__VITE_ASSET__0IBftSdw__"